/* const countBy = (field, arr) => {
  arr.reduce((res, value) => {
    if (!res[value[field]]) {
      res[value[field]] = 1
    } else {
      res[value[field]]++
    }
    console.log('res: ', res)
    return res
  })
} */

const countBy = (field, arr) => {
  console.log('log:', arr)
  return arr.reduce((res, value) => {
    if (!res[value[field]]) {
      res[value[field]] = 1
    } else {
      res[value[field]]++
    }
    return res
  }, [])
}

export default countBy

/*
    const siteId = 'ecossissolucoes.sharepoint.com,e13a07f6-096a-45ee-8dfa-74f532b19a7f,ab4a25d0-22db-487b-a5b6-4da8e59bd13c'
    const listId = '24e2b5f2-3b68-40f3-96a8-d154f82986d1'
    const endpoint = `sites/${siteId}/lists/${listId}/items?expand=
        fields(select=id,Title,N_x00fa_meroSEGI)
        &top=9999`
*/
